import React from "react";
import { X } from "lucide-react";

interface ConfirmationAlertProps {
  open: boolean;
  onClose: () => void;
  title: string;
  message?: any;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
}

const buttonStyles: Record<string, string> = {
  Approve: "bg-green-600 hover:bg-green-700",
  Decline: "bg-red-600 hover:bg-red-700",
};

const ConfirmationAlert: React.FC<ConfirmationAlertProps> = ({
  open,
  onClose,
  title,
  message,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg relative">
        {/* Close Icon */}
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          <X size={22} />
        </button>

        {/* Title */}
        <h2 className="text-lg font-semibold mb-2 text-gray-800 capitalize">
          {title}
        </h2>

        {/* Message */}
        <div className="text-gray-600 mb-6">{message}</div>

        {/* Buttons */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100 text-gray-500"
          >
            {cancelText}
          </button>

          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-md text-white ${
              buttonStyles[confirmText] ?? "bg-gray-600 hover:bg-gray-700"
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationAlert;
